import { useContext } from "react";

import type { Direction } from "./contexts";
import { DirectionContext, isDirection } from "./contexts";

export const useDirection = (dir?: Direction): Direction => {
  const contextDirection = useContext(DirectionContext);
  if (dir && isDirection(dir)) {
    return dir;
  }

  return contextDirection || (isDirection(document.dir) && document.dir) || "ltr";
};
